// extracted by mini-css-extract-plugin
export default {"root":"DeleteConfirm_root__5sTra","content":"DeleteConfirm_content__INzEN","info":"DeleteConfirm_info__MVQ8a","actions":"DeleteConfirm_actions__IN5dI"};